/**
 * pi-nonograms - A game of nonograms
 * https://github.com/DomenicoDeFelice/Pi-Nonograms
 *
 * Copyright (c) 2013-2020 Domenico De Felice
 * Released under the GNU GPL v3 License
 *
 * @license
 * @format
 * @flow
 */

const $ = require('jquery');
const Srand = require('seeded-rand');
const Nonogram = require('../src/Nonogram.js');

let nonogram;

const difficultyLabels = {
  '2': 'very easy',
  '3': 'easy',
  '4': 'normal',
  '5': 'medium',
  '6': 'hard',
  '7': 'very hard',
};

function densityFromDifficulty(difficulty: number): number {
  return (10 - difficulty) / 10;
}

function playNonogram(
  nonogramSeed?: number,
  difficulty?: number,
  width?: number,
  height?: number
): void {
  const theme = $('#theme').val();

  // nonogramSeed is used as seed for the PRNG: same seed generates
  // same nonogram.
  // If nonogramSeed is undefined, a random seed is set.
  const rnd = new Srand(nonogramSeed);

  // Gets the seed. If nonogramSeed is defined, seed will be equal
  // to nonogramSeed, otherwise it will be a randomly chosen seed.
  const seed = rnd.seed();

  width = width ?? getWidth();
  height = height ?? getHeight();

  nonogram = new Nonogram($('#nonogram'), {
    width,
    height,
    theme: theme,
    srand: rnd,
  });

  difficulty = difficulty ?? getDifficulty();

  nonogram.randomize(densityFromDifficulty(difficulty));

  $('#difficulty_slider').val(difficulty).trigger('change');
  $('#nonogram_id').val(`0|${width}|${height}|${difficulty}|${seed}`);
  $('#width').val(width);
  $('#height').val(height);
}

function playSelectedNonogram() {
  const nonogramId = $('#nonogram_id').val();
  const [_, width, height, difficulty, seed] = nonogramId.split('|');

  $('#difficulty_slider').val(difficulty).trigger('change');
  $('#width').val(width);
  $('#height').val(height);

  playNonogram(
    fitInRange(seed, 1, Number.MAX_VALUE),
    getDifficulty(),
    getWidth(),
    getHeight()
  );
}

function drawNewNonogram() {
  const theme = $('#theme').val();

  nonogram = new Nonogram($('#nonogram'), {
    width: getWidth(),
    height: getHeight(),
    theme: theme,
    mode: 'draw',
  });

  nonogram.show();
}

function fitInRange(stringNumber: string, min: number, max: number): number {
  let number = parseInt(stringNumber, 10);
  if (Number.isNaN(number)) {
    number = 1;
  }

  return Math.max(Math.min(number, max), min);
}

function getWidth(): number {
  const $width = $('#width');
  const width = fitInRange($width.val(), 2, 100);
  $width.val(width);
  return width;
}

function getHeight(): number {
  const $height = $('#height');
  const height = fitInRange($height.val(), 2, 100);
  $height.val(height);
  return height;
}

function getDifficulty(): number {
  const $difficulty = $('#difficulty_slider');
  const difficulty = fitInRange($difficulty.val(), 2, 7);
  $difficulty.val(difficulty).trigger('change');
  return difficulty;
}

$(function () {
  $('#demo').hide();

  $('#difficulty_slider')
    .change(function () {
      const difficulty = $(this).val();
      $('#difficulty_label').text(difficultyLabels[difficulty]);
    })
    .trigger('change');

  $('#theme')
    .change(function () {
      const newTheme = $(this).val();
      nonogram.setTheme(newTheme);
    })
    .click();

  $('#give_hint').click(() => {
    nonogram.giveHint();
  });

  $('#start_over').click(() => {
    nonogram.startOver();
  });

  $('#draw_nonogram').click(drawNewNonogram);

  $('#nonogram_id').click(function () {
    $(this).select();
  });
  $('#play_by_id').click(playSelectedNonogram);

  // Avoid accidental trigger while playing.
  $('#play, #play_by_id, #start_over, #give_hint, #draw_nonogram').click(
    function () {
      $(this).blur();
    }
  );

  $('#play')
    .click(() => playNonogram())
    .click();

  $('#demo').fadeIn(1500);
});
